import React, { Component, Fragment } from "react"
import BlockAction from "./BlockAction"
import { Button } from "ui"
import { cloneDeep } from "lodash"

export default class BlockActionList extends Component {
    addItem = () => {
        let newValue = cloneDeep(this.props.value || [])
        newValue.push({})
        this.props.onChange(newValue)
    }

    remove = index => {
        let newValue = cloneDeep(this.props.value || [])
        newValue.splice(index, 1)
        this.props.onChange(newValue)
    }

    set = (index, value) => {
        let newValue = cloneDeep(this.props.value || [])
        newValue[index] = value
        this.props.onChange(newValue)
    }

    render() {
        const values = this.props.value || []
        return (
            <Fragment>
                {values.map((action, index) => {
                    return (
                        <Fragment>
                            <BlockAction
                                onChange={value => this.set(index, value)}
                                action={action}
                                remove={() => this.remove(index)}
                            />
                        </Fragment>
                    )
                })}
                <Button onClick={() => this.addItem()} icon="plus">
                    Add another action
                </Button>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/actions/BlockActionList.js